import { useBreakpointValue } from '@chakra-ui/react';
import React from 'react';

import { LeaseExpertOpts } from '../../../../../hooks/useLeaseExpertOpts';
import {
  CreditStatus,
  ESIGN_STEP_LABEL,
  PayoffSource,
  PayoffStepStatus,
  getStepRenderState,
  getSteps,
} from '../utils';
import StepContent from './StepContent';
import Stepper, { StepperItem } from './Stepper';

type DealStepperProps = {
  activeStep: number;
  lienholder?: string | null;
  variant?: '4step' | '5step';
  creditStatus?: CreditStatus;
  onFrozenClick?: () => void;
  currentStepActions?: { description?: React.ReactNode; cta?: React.ReactNode };
  animate?: boolean;
  leaseExpertOpts: LeaseExpertOpts;
  eSignRef?: React.RefObject<HTMLDivElement>;
  payoffStepStatus?: PayoffStepStatus;
  payoffSource?: PayoffSource;
  onPayoffLookup?: () => void;
  hasSharedEmail?: boolean;
};

const DealStepper = ({
  activeStep,
  lienholder,
  variant = '5step',
  creditStatus = 'normal',
  onFrozenClick,
  currentStepActions,
  animate = false,
  leaseExpertOpts,
  eSignRef,
  payoffStepStatus,
  payoffSource,
  onPayoffLookup,
  hasSharedEmail = false,
}: DealStepperProps) => {
  const steps = getSteps({
    lienholder,
    variant,
    leaseExpertOpts,
    payoffStepStatus,
    payoffSource,
  });
  const isMobile = useBreakpointValue({ base: true, md: false });

  const items: StepperItem[] = steps.map((step, index) => {
    const renderState = getStepRenderState({
      step,
      index,
      activeStep,
      totalSteps: steps.length,
      creditStatus,
      payoffStepStatus,
      isMobile,
    });

    return {
      key: step.label,
      dir: renderState.dir,
      bgColor: renderState.bgColor,
      tailColor: renderState.tailColor,
      isFirst: renderState.isFirst,
      isLast: renderState.isLast,
      isCurrent: renderState.isCurrent,
      ref: step.label === ESIGN_STEP_LABEL ? eSignRef : undefined,
      content: (
        <StepContent
          step={step}
          state={renderState}
          currentStepActions={currentStepActions}
          onFrozenClick={onFrozenClick}
          onPayoffLookup={onPayoffLookup}
          isMobile={isMobile}
          hasSharedEmail={hasSharedEmail}
        />
      ),
    };
  });

  return <Stepper items={items} animate={animate} />;
};

export default DealStepper;
